import React, { FunctionComponent } from 'react';
import classNames from 'classnames';
import logo from '../../assets/upstart-white.png';
import logoutImage from '../../assets/logout.png';
import { useAppDispatch } from '../../redux/store';
import { Button } from '../Input/Button/Button';
import { LinkButton } from '../Input/Button/LinkButton';
import { ROUTES } from '../../utils/routes';
import { logout } from '../../utils/redux';
import styles from './styles.module.scss';
import { userHasLoggedOut } from '../../utils/session-timeout';

export const SupportSidebar: FunctionComponent = () => {
  const dispatch = useAppDispatch();

  return (
    <div className={styles.sidebarContainer}>
      <div className={styles.sidebar}>
        <div className={styles.header}>
          <img src={logo} alt="Logo" />
          Command Center
        </div>

        <LinkButton
          className={classNames(styles.sidebarButton)}
          label="Home"
          to={ROUTES.SUPPORT_DASHBOARD.getPath()}
          exact
        />
        <LinkButton
          className={classNames(styles.sidebarButton)}
          label="Create New Dealer"
          to={ROUTES.SUPPORT_DASHBOARD_NEW_DEALER.getPath()}
        />

        <div className="spacer" />
        <Button
          className={classNames(styles.sidebarButton, styles.logoutButton)}
          onClick={() => {
            userHasLoggedOut();
            logout(dispatch);
          }}
        >
          <img src={logoutImage} alt="Log Out" />
          Log Out
        </Button>
      </div>
    </div>
  );
};
